import { Flex, Heading3 } from "@nulogy/components";
import React from "react";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import CustomChartTooltip from "./CustomChartTooltip";
import generateHexCode from "./generateHexCode";

export default function StackedAreaChart(props) {
  const { data, keys, title } = props;

  return (
    <div>
      <Flex justifyContent="center">
        <Heading3>{title}</Heading3>
      </Flex>
      <ResponsiveContainer height={500} width="100%">
        <AreaChart
          data={data}
          height={400}
          margin={{
            bottom: 0,
            left: 0,
            right: 50,
            top: 10,
          }}
          width={500}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomChartTooltip />} />
          {keys?.map((key) => {
            const hexColor = generateHexCode(key);

            return <Area dataKey={key} fill={hexColor} key={key} stackId="1" stroke={hexColor} type="monotone" />;
          })}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
